export function initScrollyPlugin() {
    if (document.querySelector('.js-scrolly-wrapper')) {
        import('./scrollytelling.js')
            .then(module => module.default())
            .catch(err => console.error(err));
    }
}
